import { settings } from "survey-creator-core";

export default function Settings() {
  settings.themeEditor.exportFileName = "subscriptions_theme.json";
  settings.designer.defaultAddQuestionType = "consent";
}
